import React, { useState, useCallback } from "react";
import "./Tab.scss";

/**
 * Tab 컴포넌트
 *
 * @param {Array} tabs - 탭 데이터 배열
 * @param {number} defaultActiveTab - 기본 활성 탭 인덱스
 * @param {Function} onTabChange - 탭 변경 시 호출되는 콜백 함수
 * @param {string} className - 추가 CSS 클래스명
 */

const Tab = ({
    tabs = [],
    defaultActiveTab,
    onTabChange,
    className = "",
    marginTop = 0,
}) => {
    return (
        <div
            className={`tab-container ${className}`}
            style={{ marginTop: marginTop + "px" }}
        >
            <div className="tab-list" role="tablist">
                {tabs.map((tab, idx) => {
                    const isActive = idx + 1 === defaultActiveTab;
                    return (
                        <button
                            key={tab.id}
                            className={`tab-item ${isActive ? "active" : ""}`}
                            role="tab"
                            aria-selected={isActive}
                            aria-controls={`tabpanel-${tab.id}`}
                            onClick={() => onTabChange(tab.id)}
                            aria-label={tab.name}
                        >
                            <span className="tab-name">{tab.name}</span>
                            {tab.dot && <span className="dot">N</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default Tab;
